import { getSectionHeadingPath } from '/src/utils/apiFunctions';
import httpClient from '/src/utils/httpClient';

export function updateDonationApiCall({
  id,
  isPathDesign,
  donationIcon,
  donationPrice,
  donationTitle,
  donationMessage,
  donationButtonTitle,
  donationButtonBackgroundColor,
  donationButtonTextColor,
  donationHeader,
  isDonationComment,
  isDonationName,
  isDonationPhone,

  donationType,
  donationView,

  donationThemeColor,
  donationThemeTextColor,

  headingTitle,
  headingDescription,
  headingTextAlign,
  headingImage,
  headingDivider,

  sectionBorderColor,
  sectionIsBackground,
  sectionTextColor,
  sectionBackgroundColor,
  sectionOpacity,
  sectionMargin,
  sectionPadding,
  sectionIsFullWidth,
  sectionShadow,
  sectionShadowColor,
  sectionShadowBorderColor,
  sectionShape,
  sectionBackgroundType,
  sectionBackgroundImage,
  sectionGradientColor1,
  sectionGradientColor2,
  sectionGradientDirection,
  sectionGradientOffset,
  sectionBorder,
}) {
  return httpClient.put(getSectionHeadingPath('donation', isPathDesign), {
    id,
    itemIcon: donationIcon,
    itemPrice: donationPrice,
    itemTitle: donationTitle,
    message: donationMessage,
    buttonText: donationButtonTitle,
    header: donationHeader,
    isComment: isDonationComment,
    isName: isDonationName,
    isPhone: isDonationPhone,

    type: donationType,
    view: donationView,

    themeColor: donationThemeColor,
    themeTextColor: donationThemeTextColor,
    buttonColor: donationButtonBackgroundColor,
    buttonTextColor: donationButtonTextColor,

    headingTitle,
    headingDescription,
    headingTextAlign,
    headingImage,
    headingDivider,

    sectionBorderColor,
    isSectionBackground: sectionIsBackground,
    sectionTextColor,
    sectionBackgroundColor,
    sectionOpacity,
    sectionMargin,
    sectionPadding,
    sectionIsFullWidth,
    sectionShadow,
    sectionShadowColor,
    sectionShadowBorderColor,
    sectionShape,
    sectionBackgroundType,
    sectionBackgroundImage,
    sectionGradientColor1,
    sectionGradientColor2,
    sectionGradientDirection,
    sectionGradientOffset,
    sectionBorder,
  });
}
